/**
 * Страницы, которые открыты без входа: лендинг, каталог, карточки каналов,
 * витрины, блог.
 *
 * Истёкший или чужой токен рекламодателя на них не повод ни выгонять
 * посетителя на главную, ни показывать окно входа: он мог прийти из поиска
 * или из кабинета паблишера, где токена рекламодателя нет вовсе.
 *
 * Имена — как их даёт файловый роутер Nuxt: pages/blog/[topic]/[slug].vue
 * превращается в blog-topic-slug.
 */
export const PUBLIC_ROUTE_NAMES = [
  "main",
  "place",
  "catalog",
  "news",
  "index",
  "s-url",
  "ch-id",
  "dialogs",
  "contacts",
  "help",
  "about",
  "base",
  "blog",
  "blog-topic",
  "blog-topic-slug",
  "blog-tag-tag",
  "blog-preview",
  "blog-max",
];

export const isPublicRoute = (name?: string | null) =>
  !!name && PUBLIC_ROUTE_NAMES.includes(String(name));
